import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BudgetState {
  type: string | null;
}

const initialState: BudgetState = {
  type: null,
} as BudgetState;

const budgetSlice = createSlice({
  name: "budget",
  initialState,
  reducers: {
    setBudgetType(state, action: PayloadAction<string | null>) {
      state.type = action.payload;
    },
  },
});

export const { setBudgetType } = budgetSlice.actions;
export default budgetSlice.reducer;
